module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('h2', [_vm._v("Simple")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Striped Full Width Table")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10px"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Task")]), _vm._v(" "), _c('th', [_vm._v("Progress")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40px"
    }
  }, [_vm._v("Label")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1.")]), _vm._v(" "), _c('td', [_vm._v("Update software")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "progress progress-xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-danger",
    staticStyle: {
      "width": "55%"
    }
  })])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge bg-red"
  }, [_vm._v("55%")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2.")]), _vm._v(" "), _c('td', [_vm._v("Clean database")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "progress progress-xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-yellow",
    staticStyle: {
      "width": "70%"
    }
  })])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge bg-yellow"
  }, [_vm._v("70%")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3.")]), _vm._v(" "), _c('td', [_vm._v("Cron job running")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "progress progress-xs progress-striped active"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-primary",
    staticStyle: {
      "width": "30%"
    }
  })])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge bg-light-blue"
  }, [_vm._v("30%")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4.")]), _vm._v(" "), _c('td', [_vm._v("Fix and squish bugs")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "progress progress-xs progress-striped active"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-success",
    staticStyle: {
      "width": "90%"
    }
  })])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge bg-green"
  }, [_vm._v("90%")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('h2', [_vm._v("Data tables")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Data Table With Full Features")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "sorting_asc",
    staticStyle: {
      "width": "167px"
    },
    attrs: {
      "aria-label": "Rendering engine: activate to sort column descending",
      "aria-sort": "ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Rendering engine")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "207px"
    },
    attrs: {
      "aria-label": "Browser: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Browser")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "182px"
    },
    attrs: {
      "aria-label": "Platform(s): activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Platform(s)")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "142px"
    },
    attrs: {
      "aria-label": "Engine version: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Engine version")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "101px"
    },
    attrs: {
      "aria-label": "CSS grade: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("CSS grade")])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Blink")]), _vm._v(" "), _c('td', [_vm._v("Iridium  54.0")]), _vm._v(" "), _c('td', [_vm._v("GNU/Linux")]), _vm._v(" "), _c('td', [_vm._v("54")]), _vm._v(" "), _c('td', [_vm._v("A")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Gecko")]), _vm._v(" "), _c('td', [_vm._v("Firefox 1.0")]), _vm._v(" "), _c('td', [_vm._v("Win 98+ / OSX.2+")]), _vm._v(" "), _c('td', [_vm._v("1.7")]), _vm._v(" "), _c('td', [_vm._v("A")])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Gecko")]), _vm._v(" "), _c('td', [_vm._v("Firefox 1.5")]), _vm._v(" "), _c('td', [_vm._v("Win 98+ / OSX.2+")]), _vm._v(" "), _c('td', [_vm._v("1.8")]), _vm._v(" "), _c('td', [_vm._v("A")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Gecko")]), _vm._v(" "), _c('td', [_vm._v("Firefox 2.0")]), _vm._v(" "), _c('td', [_vm._v("Win 98+ / OSX.2+")]), _vm._v(" "), _c('td', [_vm._v("1.8")]), _vm._v(" "), _c('td', [_vm._v("A")])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Gecko")]), _vm._v(" "), _c('td', [_vm._v("Firefox 3.0")]), _vm._v(" "), _c('td', [_vm._v("Win 2k+ / OSX.3+")]), _vm._v(" "), _c('td', [_vm._v("1.9")]), _vm._v(" "), _c('td', [_vm._v("A")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Gecko")]), _vm._v(" "), _c('td', [_vm._v("Camino 1.0")]), _vm._v(" "), _c('td', [_vm._v("OSX.2+")]), _vm._v(" "), _c('td', [_vm._v("1.8")]), _vm._v(" "), _c('td', [_vm._v("A")])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Gecko")]), _vm._v(" "), _c('td', [_vm._v("Camino 1.5")]), _vm._v(" "), _c('td', [_vm._v("OSX.3+")]), _vm._v(" "), _c('td', [_vm._v("1.8")]), _vm._v(" "), _c('td', [_vm._v("A")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Gecko")]), _vm._v(" "), _c('td', [_vm._v("Netscape 7.2")]), _vm._v(" "), _c('td', [_vm._v("Win 95+ / Mac OS 8.6-9.2")]), _vm._v(" "), _c('td', [_vm._v("1.7")]), _vm._v(" "), _c('td', [_vm._v("A")])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Gecko")]), _vm._v(" "), _c('td', [_vm._v("Netscape Browser 8")]), _vm._v(" "), _c('td', [_vm._v("Win 98SE+")]), _vm._v(" "), _c('td', [_vm._v("1.7")]), _vm._v(" "), _c('td', [_vm._v("A")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Gecko")]), _vm._v(" "), _c('td', [_vm._v("Netscape Navigator 9")]), _vm._v(" "), _c('td', [_vm._v("Win 98+ / OSX.2+")]), _vm._v(" "), _c('td', [_vm._v("1.8")]), _vm._v(" "), _c('td', [_vm._v("A")])]), _vm._v(" "), _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v("Gecko")]), _vm._v(" "), _c('td', [_vm._v("Mozilla 1.0")]), _vm._v(" "), _c('td', [_vm._v("Win 95+ / OSX.1+")]), _vm._v(" "), _c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("A")])])]), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Rendering engine")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Browser")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Platform(s)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Engine version")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("CSS grade")])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf99a136"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Tables.vue
// module id = 1915
// module chunks = 1